/**
 * AnalyticsInit - Stuurt page views naar eigen analytics API (alleen bij cookie-opt-in).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';
import { useCookieConsent } from '../lib/CookieConsentContext';

export function AnalyticsInit() {
  const location = useLocation();
  const { analyticsEnabled } = useCookieConsent();

  useEffect(() => {
    if (!analyticsEnabled) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search, analyticsEnabled]);

  return null;
}
